import {
  CollapsibleSidebarRoot,
  CollapsibleSidebarItem,
  DESKTOP_WIDTH,
} from "./CollapsibleSidebar"
import { CollapsibleSidebarActiveDot } from "./CollapsibleSidebarActiveDot"

export const CollapsibleSidebar = {
  Root: CollapsibleSidebarRoot,
  Item: CollapsibleSidebarItem,
  ActiveDot: CollapsibleSidebarActiveDot,
} as const

export { DESKTOP_WIDTH }
